// extracted by mini-css-extract-plugin
export default {"panel":"panel__Je2ya"};